import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { incidentIdField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';

export const workplaceReportsMetadata = {
  displayName: msg({
    message: 'Workplace incidents',
    context: 'Activity data schema name for workplace incidents',
  }),
  fields: {
    ...coreFields,
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Workplace report remediation spend',
        context: 'The display name for a metric',
      }),
      externalDescription: msg({
        message:
          'The monetary amount spent on workplace incident remediation, such as fines, penalties, and compensation for damages.',
      }),
    },
    incident_id: incidentIdField,
    is_discrimination: {
      displayName: msg({
        message: 'Is discrimination',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether the workplace incident involves an allegation of discrimination.',
      }),
    },
    is_filed_by_own_workforce: {
      displayName: msg({
        message: 'Is filed by own workforce',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          "Whether the workplace incident complaint was filed by a member of the company's own workforce.",
      }),
    },
    is_filed_to_national_contact_points_for_oecd: {
      displayName: msg({
        message:
          'Is filed to National Contact Points for OECD Multinational Enterprises',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether the workplace incident complaint was filed with National Contact Points for OECD Guidelines for Multinational Enterprises.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
